import api from './api';
import { IngresosGastos } from '../types/IngresosGastos';

export const ingresosGastosService = {
  getAll: (idInmueble: string, year: number) =>
    api.get<IngresosGastos[]>(`/ingresos-gastos?idInmueble=${idInmueble}&year=${year}`),
  create: (data: IngresosGastos) => api.post<IngresosGastos>('/ingresos-gastos', data),
  update: (id: string, data: IngresosGastos) => api.put<IngresosGastos>(`/ingresos-gastos/${id}`, data),
  delete: (id: string) => api.delete(`/ingresos-gastos/${id}`),
};
